import { createAction } from '@reduxjs/toolkit';
import { SessionType } from '../types';

export const setNextSessions = createAction<SessionType[]>('GET_NEXT_SESSIONS');

export const setPastSessions = createAction<SessionType[]>('GET_PAST_SESSIONS');
